import { observer } from 'mobx-react';
import { NonEmptyList } from 'nonempty-list';
import { LicenseInsightResource } from './Decoder';
import LicenseAlert from './LicenseAlert';

interface Props {
  licenseInsights: NonEmptyList<LicenseInsightResource>;
}

function Overview({ licenseInsights }: Props) {
  return licenseInsights
    .toArray()
    .map((insight, index) => (
      <LicenseAlert key={index} index={index} licenseInsight={insight.payload} />
    ));
}
export default observer(Overview);
